import React from "react"
import BlogListItem from "../blog-list/blog-list-item"
import { Link } from "gatsby"
import { ReactComponent as Arrow } from "@svgs/arrow.svg"
import Section from "@components/section"

const RecommendedBlogs = ({ 
  title = `You might also like`, 
  intro = `Crate training tips, stories and inspiration`, 
  atc = {
    text: "View all blogs",
    internalLink: "/blog",
  }, 
  blogs = [],
}) => {
  return (
    <Section settings={{ classname:"overflow-hidden", isContainer: true }} containerClassname="!pr-0 xl:!pr-[60px]">
      <div className="flex flex-row overflow-x-auto overflow-y-hidden sm:scrolling-touch max-md:pb-2.5 w-full">
        <div className={`${blogs.length > 0 ? 'md:w-[430px] h-[400px]' : ''} h-full min-w-[280px] md:min-w-[315px] md:w-1/4 md:shrink-0 bg-calm-yellow p-5 sm:p-10 rounded-xl`}>
          <div className="flex flex-col h-full">
            <h2 className="text-4xl">{title}</h2>
            <div className="flex mt-auto flex-col gap-10">
              <p className="text-base leading-5">{intro}</p>
              <Link
                to={atc.internalLink}
                className="btn w-full btn-primary flex items-center hover:bg-calm-yellow"
              >
                {atc.text}
                <Arrow className="ml-2 arrow" />
              </Link>
            </div>
          </div>
        </div>
        {blogs.length > 0 && 
        <div
        className="flex flex-no-wrap scrolling-touch px-5 gap-5 md:overflow-x-auto w-full"
      >
        {blogs.map((blog, index) => (
          <BlogListItem key={`blog-${index}`} {...blog} className={'min-w-[380px] w-full'}/>
        ))}
      </div>}
      </div>
    </Section>
  )
}

export default RecommendedBlogs
